export default "__VITE_ASSET__BsWlibJt__"